<template>
    <div class="container-fluid">
        <div class="row">
            <productcategorylist />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const productcategorylist = defineAsyncComponent(() => import("@/components/theme/ecommerce/productcategory/productcategorylist.vue"))
</script>